import React from 'react'
import { connect } from 'react-redux'
import { store } from '../../../store/index'

import Button from 'components/Button'
import LazyLoad from 'react-lazyload'
import Placeholder from 'components/Placeholder'

import { SETTINGS_PAGINATION, MODAL_ALERT_TYPES, CONFIG_BASE_URL } from 'utils/consts'
import actions from 'store/actions'

import noImage from 'assets/images/no-image.svg'
import closeBtn from 'assets/images/close.svg'

class ModalAddUsersToGroup extends React.Component {
  constructor() {
    super()
    this.selectedUsers = new Set()
  }

  state = {
    users: [],
    itemsPerPage: SETTINGS_PAGINATION.COUNT_PER_PAGE_MAX,
    pageNumber: SETTINGS_PAGINATION.PAGE_NUMBER,
    errorText: '',
  }

  componentDidMount() {
    this.fetchUsers()
  }

  fetchUsers = async () => {
    const { itemsPerPage, pageNumber } = this.state

    try {
      const response = await this.props.fetchUsers(itemsPerPage, pageNumber)
      this.setState({ users: response.objects })
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  createGroup = async () => {
    if (!this.selectedUsers.size) {
      this.setState({ errorText: 'Выберите сотрудника' })
    } else {
      try {
        const usersID = []
        this.selectedUsers.forEach(user => usersID.push(user))

        const data = [
          {
            group_id: this.props.group.id,
            employee_id: usersID,
            access_object_id: [],
          },
        ]

        this.props.closeModal()
        await this.props.createGroup(data)
        await this.props.fetchGroups({
          count: SETTINGS_PAGINATION.COUNT_PER_PAGE,
          page: SETTINGS_PAGINATION.PAGE_NUMBER,
        })
      } catch (error) {
        this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
      }
    }
  }

  /**
   * @param {Number} userID
   */
  toggleUser = userID => {
    if (this.selectedUsers.has(userID)) {
      this.selectedUsers.delete(userID)
    } else {
      this.selectedUsers.add(userID)
    }
  }

  /**
   * @param {Object} e
   */
  handleScroll = async e => {
    const { itemsPerPage, pageNumber } = this.state
    const element = e.target,
      data = {
        count: itemsPerPage,
        page: pageNumber + 1,
      }

    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      const response = await this.props.fetchUsers(data)
      this.setState(prevState => ({
        users: [...prevState.users, ...response.objects],
        pageNumber: prevState.pageNumber + 1,
      }))
    }
  }

  render() {
    const { users, errorText } = this.state
    const { access } = store.getState().tokenInfo

    return (
      <>
        <div className='modal-overlay'>
          <div className='modal modal--sm'>
            <div className='modal__header'>
              <p className='modal__title'>Добавить сотрудника в группу</p>
              <Button
                className='button--icon'
                icon={true}
                iconPicture={closeBtn}
                action={this.props.closeModal}
              />
            </div>

            <div className='modal__content'>
              {errorText && <div className='error'>{errorText}</div>}
              <div
                className='users-list overflow-list'
                onScroll={this.handleScroll}>
                {users.map(user => (
                  <LazyLoad
                    key={user.id}
                    once
                    overflow
                    height={52}
                    offset={[-10, 0]}
                    placeholder={<Placeholder />}
                    debounce={200}>
                    <div className='users-list__user'>
                      <label>
                        <input
                          type='checkbox'
                          onChange={() => this.toggleUser(user.id)}
                        />
                        <div
                          className='wrapper-photo'
                          style={{
                            backgroundImage: `url(${
                              user.photo.length && user.photo[0].url_path
                                ? CONFIG_BASE_URL +
                                  `${user.photo[0].url_path}?token=${access}`
                                : noImage
                            }`,
                          }}></div>
                        <div>
                          <div className='user-name'>{user.title}</div>
                          <div className='user-status'>
                            {user.is_active ? 'Активен' : 'Неактивен'}
                          </div>
                        </div>
                      </label>
                    </div>
                  </LazyLoad>
                ))}
              </div>
            </div>

            <div className='modal__bottom modal__bottom--right'>
              <Button
                title='Добавить'
                className='btn--lg btn--primary'
                action={this.createGroup}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createGroup: data => dispatch(actions.groups.createGroup(data)),
    fetchGroups: data => dispatch(actions.groups.fetchGroups(data)),
    fetchUsers: data => dispatch(actions.users.fetchUsers(data)),
  }
}

export default connect(null, mapDispatchToProps)(ModalAddUsersToGroup)
